import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

/* Modified มาจาก
SelectTambol.js
*/

export default function Asynchronous(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const { rhf, control, name, province } = props;

  // เมื่อจังหวัดเปลี่ยน ให้ fetch ข้อมูลอำเภอใหม่ทันที
  React.useEffect(() => {
    let active = true;

    if (!province?.id) {
      setOptions([]);
      return undefined;
    }

    (async () => {
      console.log('---SelectDistrict.js fetching districts for province---', province);
      
      var config = {
        method: 'get',
        url: `/api/cis/district/${province.id}`,
      };

      axios(config)
        .then(function (response) {
          response.data = response.data.filter((category) => category.name);
          if (active) {
            setOptions([...response.data]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    })();

    return () => {
      active = false;
    };
  }, [province?.id]);


  // รวม value ปัจจุบันเข้าไปใน options ถ้ายังไม่มี (สำหรับแสดงค่าเริ่มต้น)
  const getOptionsWithValue = (opts, currentValue) => {
    if (!currentValue || !currentValue.id) return opts;
    const hasValue = opts.some(opt => opt.id === currentValue.id);
    if (hasValue) return opts;
    return [currentValue, ...opts];
  };

  return (
    <rhf.Controller
      render={({ field, fieldState: { error } }) => {
        const optionsToShow = getOptionsWithValue(options, field.value);
        return (
          <Autocomplete
            id="district-select"
            options={optionsToShow}
            value={field.value || null}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            getOptionLabel={(option) => option.name || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(_, data) => field.onChange(data)}
            loading={loading}
            renderOption={(props, option) => {
              return (
                <li {...props} key={option.id}>
                  {option.name}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="อำเภอ"
                variant="filled"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        );
      }}
      name={name}
      control={control}
    />
  );
}
